// extracted by mini-css-extract-plugin
export default {"item":"styles_item__LDED4","popup":"styles_popup__QnZ-g"};